// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--1qL8G","smaller":"title-module--smaller--2UqNs"};